import _ from 'lodash'
import constants from '@/libs/constant/constants'
import {removeAuthorListing} from '@/libs/api/api'
import {message, errorHandler, logout, loader, getImageUrl, onError} from '@/libs/helper'

export default{
    name: 'RegisteredList',
    props:{
        item: {
            type: Object,
            default: () => {}
        },
        updateList: {
            type: Function,
            default: () => {}
        },
        module: {
            type: String,
            default: () => constants.AUTHOR.key
        },
        isEdit: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            getImageUrl: getImageUrl,
            onError: onError
        }
    },
    methods:{
        routeToDetailPage(record){
            this.$router.push(`${this.module.toLowerCase()}s/details/${record._id}`)
        },
        /**
         * Converts the UTC date into "dd-mm-yyyy hh:mm" format .
         * @param {string} date into UTC format
         */
        getDate (date) {
            if (date !== undefined && date !== null) {
                let d = new Date(date)
                return ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
                    d.getFullYear() + ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2)
            }
        },
        routeTo(route){
            this.$store.dispatch('setInformationToEdit', this.item)
            this.$router.push(route)
        },
        openRemovePopup(module){
            const mainTitle = window.i18next.t(this.getRemovePopupHeading(module));
            const nameTitle = this.item.name;
            const popUpfor = constants[module].value
            const html =
                `<div class="remove-list-warning-container">
                    <div class="popup-title"><span>
                    ` + mainTitle +`
                    </span>: <span class="listing-name">
                    ` + nameTitle + `
                    </span></div>
                    <div class="warning-text-container">
                        <div class="warning-icon">
                            <i class="nova-warningalert"></i>
                        </div>
                        <div class="warning-text">
                            When you remove a listing, you can no longer make any changes to it. Also, another User can take over the management of the listing.
                        </div>
                    </div>
                    <div class="warning-confirmation-text">
                        Are you sure you would like to remove this listing, it can not be undone?
                    </div>
                    <div class="follow-checkbox">
                        <input class="checkbox" id="checkbox" type="checkbox" checked/>
                        <span class="checkbox-label">Keep following this `+ popUpfor +`</span>
                    </div>
                </div>`

            this.$confirm(`${html}`, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: window.i18next.t('Remove'),
                cancelButtonText: window.i18next.t('Cancel'),
                showClose: false,
                closeOnClickModal: false,
                customClass: 'confirmBox'
            }).then(() => {
                this.removeListingAPI(module)
            }).catch(() => {})
        },
        removeListingAPI(module){
            loader(this, true)
            let checkbox = document.getElementById('checkbox').checked

            let body = {
                following: checkbox,
                id: this.item._id,
                type: module
            }

            removeAuthorListing(body)
                .then((response)=>{
                    loader(this, false)
                    this.updateStoreListing(module, body, checkbox)
                    message(this, constants.messageType.SUCCESS, (response.message))
                    document.getElementById('checkbox').checked = true
                    this.updateList()
                })
                .catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })
        },
        selectRouteTo(module){
            switch (module){
                case constants.AUTHOR.key:
                    this.routeTo('edit-author-card')
                    break
                case constants.PUBLISHER.key:
                    this.routeTo('edit-publisher-card')
                    break
                case constants.PUBLICATION.key:
                    this.routeTo('edit-publication-card')
                    break
            }
        },
        updateStoreListing(module, body, checkbox){
            switch (module){
                case constants.AUTHOR.key:
                    this.$store.dispatch('removeRegisteredAuthor', {_id: body.id})
                    if(!checkbox){
                        let authorsFollowings = _.cloneDeep(this.$store.getters.getUserFollowings.author || [])
                        authorsFollowings = authorsFollowings.filter(af => af._id !== body.id)
                        this.$store.dispatch('updateUserFollowingsAuthorToStore', authorsFollowings)
                    }
                    break
                case constants.PUBLISHER.key:
                    this.$store.dispatch('removeRegisteredPublisher', {_id: body.id})
                    if(!checkbox){
                        let publisherFollowings = _.cloneDeep(this.$store.getters.getUserFollowings.publisher || [])
                        publisherFollowings = publisherFollowings.filter(af => af._id !== body.id)
                        this.$store.dispatch('updateUserFollowingsPublisherToStore', publisherFollowings)
                    }
                    break
                case constants.PUBLICATION.key:
                    this.$store.dispatch('removeRegisteredPublication', {_id: body.id})
                    if(!checkbox){
                        let publicationFollowings = _.cloneDeep(this.$store.getters.getUserFollowings.publication || [])
                        publicationFollowings = publicationFollowings.filter(af => af._id !== body.id)
                        this.$store.dispatch('updateUserFollowingsPublicationToStore', publicationFollowings)
                    }
                    break
            }
        },
        getEditLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Edit Author'
                case constants.PUBLISHER.key:
                    return 'Edit Publisher'
                case constants.PUBLICATION.key:
                    return 'Edit publication'
                case 'USER': 
                return 'Edit User'   
            }
        },
        getDeleteLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Remove Author'
                case constants.PUBLISHER.key:
                    return 'Remove Publisher'
                case constants.PUBLICATION.key:
                    return 'Remove publication'
                case 'USER': 
                    return 'Remove User'    
            }
        },
        getRemovePopupHeading(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Remove Author listing'
                case constants.PUBLISHER.key:
                    return 'Remove Publisher listing'
                case constants.PUBLICATION.key:
                    return 'Remove publication listing'
            }
        },
        removeMeta (type) {
            this.$emit('removeMeta', type, this.item)
        },
        editMeta (type, id) {
            switch (type) {
                case constants.AUTHOR.key:
                    this.$store.dispatch('setType', type)
                    this.$router.push({name: 'editAuthors', params: {id}})
                    break    
                case constants.PUBLISHER.key:
                    this.$store.dispatch('setType', type)
                    this.$router.push({name: 'editPublishers', params: {id}})
                    break
                        
                case constants.PUBLICATION.key:
                    this.$store.dispatch('setType', type)
                    this.$router.push({name: 'editPublications', params: {id}})
                    break 
                case 'USER': 
                    this.$store.dispatch('setType', type)
                    this.$router.push({name: 'editUsers', params: {id}})
                    break       
            }
            
        }
    }
}